function UsersView({
  users,
  userForm,
  setUserForm,
  saveUserPermission,
  updateUserPermission,
  updateUserCompanyAssignmentsOnly,
  removeUserPermission,
  sendPasswordResetToUser,
  generatePasswordResetLinkForUser,
  currentUserEmail,
  canGrantParasutAccess = false,
  firmaListesi = [],
  processProjects = [],
  themeMode = "light",
  isAdmin = false,
  canAssignCompanies = false
}) {
  const adminCount = users.filter((u) => u.role === "admin").length;
  const isEditMode = Boolean(userForm.editingUserId);
  const assignmentOnlyMode = !isAdmin && canAssignCompanies;
  const isDark = themeMode === "dark";
  const colors = {
    text: isDark ? "#e5edf6" : "#111827",
    muted: isDark ? "#9ca3af" : "#64748b",
    panel: isDark ? "#162235" : "#ffffff",
    panel2: isDark ? "#101b2d" : "#f9fafb",
    input: isDark ? "#101827" : "#ffffff",
    border: isDark ? "#2c3d55" : "#dbe2ea",
    softBorder: isDark ? "#26364d" : "#e5e7eb",
    button: isDark ? "#1f2d44" : "#f3f4f6",
    selectedBg: isDark ? "#123423" : "#dcfce7",
    selectedBorder: isDark ? "#2f7d4f" : "#86efac",
    selectedText: isDark ? "#bbf7d0" : "#14532d"
  };
  const inputStyle = {
    padding: "14px 16px",
    borderRadius: 12,
    border: `1px solid ${colors.border}`,
    background: colors.input,
    color: colors.text,
    fontSize: 14,
    outline: "none"
  };
  const getAssignmentLabelStyle = (checked) => ({
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "9px 10px",
    borderRadius: 10,
    background: checked ? colors.selectedBg : colors.input,
    border: checked ? `1px solid ${colors.selectedBorder}` : `1px solid ${colors.softBorder}`,
    color: checked ? colors.selectedText : colors.text,
    cursor: "pointer",
    fontSize: 13,
    fontWeight: 700
  });

  const firmalar = [...(firmaListesi || [])]
    .map((firma) => firma.firmaAdi)
    .filter(Boolean)
    .sort((a, b) => String(a).localeCompare(String(b), "tr"));

  const assignedCompanyReport = users
    .map((u) => ({
      ...u,
      assignedCompanies: Array.isArray(u.assignedCompanies)
        ? u.assignedCompanies.filter(Boolean)
        : []
    }))
    .filter((u) => u.assignedCompanies.length > 0);

  const resetUserForm = () => {
    setUserForm({
      email: "",
      password: "",
      name: "",
      hireDate: "",
      role: "viewer",
      accessMode: "all",
      assignedCompanies: [],
      canAssignCompanies: false,
      canMonitorBackups: false,
      canManageParasut: false,
      processProjectAccessMode: "all",
      assignedProcessProjects: [],
      isActive: true,
      editingUserId: null
    });
  };

  const handleEditUser = (u) => {
    setUserForm({
      email: u.email || "",
      password: "",
      name: u.name || "",
      hireDate: u.hireDate || "",
      role: u.role || "viewer",
      accessMode: "all",
      assignedCompanies: u.assignedCompanies || [],
      canAssignCompanies: u.canAssignCompanies === true,
      canMonitorBackups: u.role === "admin" && u.canMonitorBackups === true,
      canManageParasut: u.role === "admin" && u.canManageParasut === true,
      processProjectAccessMode: u.processProjectAccessMode || "all",
      assignedProcessProjects: u.assignedProcessProjects || [],
      isActive: u.isActive !== false,
      editingUserId: u.uid || u.id
    });
  };

  const handleSubmit = async () => {
    if (isEditMode) {
      if (assignmentOnlyMode) {
        await updateUserCompanyAssignmentsOnly({
          uid: userForm.editingUserId,
          email: userForm.email,
          assignedCompanies: userForm.assignedCompanies || []
        });

        resetUserForm();
        return;
      }

      await updateUserPermission({
        uid: userForm.editingUserId,
        email: userForm.email,
        name: userForm.name,
        hireDate: userForm.hireDate,
        role: userForm.role,
        accessMode: "all",
        assignedCompanies: userForm.assignedCompanies || [],
        canAssignCompanies: userForm.canAssignCompanies === true,
        canMonitorBackups: userForm.role === "admin" && userForm.canMonitorBackups === true,
        canManageParasut: userForm.role === "admin" && userForm.canManageParasut === true,
        processProjectAccessMode: userForm.processProjectAccessMode || "all",
        assignedProcessProjects: userForm.assignedProcessProjects || [],
        isActive: userForm.isActive !== false,
        password: userForm.password || ""
      });

      resetUserForm();
      return;
    }

    await saveUserPermission();
  };

  return (
    <div style={{ color: colors.text }}>
      <h2>{assignmentOnlyMode ? "Firma Atama Raporu" : "Kullanıcı Yönetimi"}</h2>

      <div style={{ background: colors.panel, color: colors.text, padding: 24, borderRadius: 18, border: `1px solid ${colors.softBorder}`, boxShadow: isDark ? "0 12px 28px rgba(0,0,0,0.18)" : "0 8px 24px rgba(0,0,0,0.06)", marginBottom: 24 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
            marginBottom: 16
          }}
        >
          <h3 style={{ margin: 0 }}>
            {assignmentOnlyMode
              ? isEditMode
                ? "Kullanıcının Firma Atamasını Güncelle"
                : "Kullanıcı seçerek firma ataması yapabilirsiniz"
              : isEditMode
              ? "Kullanıcı Yetkisini Güncelle"
              : "Yeni Kullanıcı Yetkisi Tanımla"}
          </h3>

          {isEditMode && (
            <button
              type="button"
              onClick={resetUserForm}
              style={{
                border: "none",
                background: colors.button,
                color: colors.text,
                padding: "8px 12px",
                borderRadius: 10,
                fontWeight: 800,
                cursor: "pointer"
              }}
            >
              Vazgeç
            </button>
          )}
        </div>

        {assignmentOnlyMode && !isEditMode && (
          <div style={{ padding: 14, borderRadius: 14, background: colors.panel2, border: `1px solid ${colors.softBorder}`, color: colors.muted, fontWeight: 800 }}>
            Aşağıdaki kullanıcı listesinden “Düzenle” butonuna basarak yalnızca firma ataması yapabilirsiniz.
          </div>
        )}

        {(!assignmentOnlyMode || isEditMode) && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: 14, alignItems: "center" }}>

          {assignmentOnlyMode ? (
            <div
              style={{
                padding: "14px 16px",
                borderRadius: 12,
                border: `1px solid ${colors.border}`,
                background: colors.panel2,
                color: colors.text,
                fontWeight: 900
              }}
            >
              Seçilen kullanıcı: {userForm.name || userForm.email || "-"}
            </div>
          ) : (
            <>
              <input
                type="text"
                placeholder="Ad Soyad"
                value={userForm.name || ""}
                onChange={(e) =>
                  setUserForm({
                    ...userForm,
                    name: e.target.value
                  })
                }
                style={inputStyle}
              />

              <input
                type="date"
                title="İşe giriş tarihi"
                value={userForm.hireDate || ""}
                onChange={(e) => setUserForm({ ...userForm, hireDate: e.target.value })}
                style={inputStyle}
              />

              <input
                type="email"
                placeholder="kullanici@firma.com"
                value={userForm.email}
                disabled={isEditMode}
                onChange={(e) =>
                  setUserForm({
                    ...userForm,
                    email: e.target.value
                  })
                }
                style={inputStyle}
              />

              <input
                type="password"
                placeholder={isEditMode ? "Yeni şifre - boşsa değişmez" : "Geçici şifre"}
                value={userForm.password}
                onChange={(e) =>
                  setUserForm({
                    ...userForm,
                    password: e.target.value
                  })
                }
                style={inputStyle}
              />
            </>
          )}

          {isAdmin && (
          <select
            value={userForm.role}
            onChange={(e) =>
              setUserForm({
                ...userForm,
                role: e.target.value,
                canMonitorBackups: e.target.value === "admin" ? userForm.canMonitorBackups : false,
                canManageParasut: e.target.value === "admin" ? userForm.canManageParasut : false
              })
            }
            style={inputStyle}
          >
            <option value="viewer">Görüntüleyici</option>
            <option value="editor">Düzenleyici</option>
            <option value="admin">Admin</option>
          </select>
          )}

          {isAdmin && (
            <label style={{ ...getAssignmentLabelStyle(userForm.canAssignCompanies === true), justifyContent: "flex-start" }}>
              <input
                type="checkbox"
                checked={userForm.canAssignCompanies === true}
                onChange={(e) =>
                  setUserForm({
                    ...userForm,
                    canAssignCompanies: e.target.checked
                  })
                }
              />
              Firma ataması yapabilir
            </label>
          )}

          {isAdmin && (
            <label
              style={{
                ...getAssignmentLabelStyle(userForm.role === "admin" && userForm.canMonitorBackups === true),
                justifyContent: "flex-start",
                opacity: userForm.role === "admin" ? 1 : 0.55,
                cursor: userForm.role === "admin" ? "pointer" : "not-allowed"
              }}
              title={userForm.role === "admin" ? "Yedek durumu ekranını görür." : "Yedek takibi yalnızca admin kullanıcıya verilebilir."}
            >
              <input
                type="checkbox"
                disabled={userForm.role !== "admin"}
                checked={userForm.role === "admin" && userForm.canMonitorBackups === true}
                onChange={(e) =>
                  setUserForm({
                    ...userForm,
                    canMonitorBackups: userForm.role === "admin" && e.target.checked
                  })
                }
              />
              Yedek takibi yapabilir
            </label>
          )}

          {isAdmin && canGrantParasutAccess && (
            <label
              style={{
                ...getAssignmentLabelStyle(userForm.role === "admin" && userForm.canManageParasut === true),
                justifyContent: "flex-start",
                opacity: userForm.role === "admin" ? 1 : 0.55,
                cursor: userForm.role === "admin" ? "pointer" : "not-allowed"
              }}
              title={userForm.role === "admin" ? "Paraşüt Cari ekranını görür ve senkronizasyon yapabilir." : "Paraşüt yetkisi yalnızca admin kullanıcıya verilebilir."}
            >
              <input
                type="checkbox"
                disabled={userForm.role !== "admin"}
                checked={userForm.role === "admin" && userForm.canManageParasut === true}
                onChange={(e) =>
                  setUserForm({
                    ...userForm,
                    canManageParasut: userForm.role === "admin" && e.target.checked
                  })
                }
              />
              Paraşüt Cari ekranını görebilir
            </label>
          )}

          {isAdmin && (
          <select
            value={userForm.processProjectAccessMode || "all"}
            onChange={(e) =>
              setUserForm({
                ...userForm,
                processProjectAccessMode: e.target.value,
                assignedProcessProjects:
                  e.target.value === "all" ? [] : userForm.assignedProcessProjects || []
              })
            }
            style={inputStyle}
          >
            <option value="all">Tüm Süreç Projeleri</option>
            <option value="assigned">Atanmış Süreç Projeleri</option>
          </select>
          )}

          <button
            type="button"
            onClick={handleSubmit}
            disabled={assignmentOnlyMode && !isEditMode}
            style={{
              padding: "14px 18px",
              borderRadius: 12,
              border: "none",
              background: isEditMode ? "#2563eb" : "#124254",
              color: "#fff",
              fontWeight: 700,
              cursor: assignmentOnlyMode && !isEditMode ? "not-allowed" : "pointer",
              opacity: assignmentOnlyMode && !isEditMode ? 0.65 : 1
            }}
          >
            {assignmentOnlyMode ? "Firma Atamasını Kaydet" : isEditMode ? "Güncelle" : "Kaydet"}
          </button>
        </div>
        )}

        {(!assignmentOnlyMode || isEditMode) && (
          <div style={{ marginTop: 18, padding: 16, borderRadius: 14, border: `1px solid ${colors.softBorder}`, background: colors.panel2 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
              <strong>Firma Ataması</strong>
              <span style={{ color: colors.muted, fontSize: 13, fontWeight: 700 }}>
                {(userForm.assignedCompanies || []).length} firma seçildi
              </span>
            </div>

            {firmalar.length === 0 ? (
              <div style={{ color: colors.muted, fontSize: 13, fontWeight: 700 }}>
                Firma listesi bulunamadı. Firma ataması için önce proje verisi yüklenmelidir.
              </div>
            ) : (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 10, maxHeight: 260, overflowY: "auto" }}>
                {firmalar.map((firmaAdi) => {
                  const checked = (userForm.assignedCompanies || []).includes(firmaAdi);

                  return (
                    <label key={firmaAdi} style={getAssignmentLabelStyle(checked)}>
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={(e) => {
                          const current = userForm.assignedCompanies || [];
                          const nextCompanies = e.target.checked
                            ? [...current, firmaAdi]
                            : current.filter((item) => item !== firmaAdi);

                          setUserForm({ ...userForm, assignedCompanies: nextCompanies });
                        }}
                      />
                      {firmaAdi}
                    </label>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {isAdmin && userForm.processProjectAccessMode === "assigned" && (
          <div style={{ marginTop: 18, padding: 16, borderRadius: 14, border: `1px solid ${colors.softBorder}`, background: colors.panel2 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
              <strong>Görüntüleyebileceği Süreç Projeleri</strong>
              <span style={{ color: colors.muted, fontSize: 13, fontWeight: 700 }}>
                {(userForm.assignedProcessProjects || []).length} süreç projesi seçildi
              </span>
            </div>

            {processProjects.length === 0 ? (
              <div style={{ color: colors.muted, fontSize: 13, fontWeight: 700 }}>
                Henüz süreç projesi bulunamadı.
              </div>
            ) : (
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 10, maxHeight: 220, overflowY: "auto" }}>
                {processProjects.map((project) => {
                  const checked = (userForm.assignedProcessProjects || []).includes(project.id);

                  return (
                    <label key={project.id} style={getAssignmentLabelStyle(checked)}>
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={(e) => {
                          const current = userForm.assignedProcessProjects || [];
                          const nextProjects = e.target.checked
                            ? [...current, project.id]
                            : current.filter((item) => item !== project.id);

                          setUserForm({ ...userForm, assignedProcessProjects: nextProjects });
                        }}
                      />
                      {project.name}
                    </label>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>

      <div style={{ background: colors.panel, color: colors.text, padding: 24, borderRadius: 18, border: `1px solid ${colors.softBorder}`, boxShadow: isDark ? "0 12px 28px rgba(0,0,0,0.18)" : "0 8px 24px rgba(0,0,0,0.06)", marginBottom: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "center", marginBottom: 14 }}>
          <h3 style={{ margin: 0 }}>Firma Atama Raporu</h3>
          <span style={{ color: colors.muted, fontWeight: 800 }}>{assignedCompanyReport.length} kullanıcıda firma ataması var</span>
        </div>

        {assignedCompanyReport.length === 0 ? (
          <div style={{ color: colors.muted, fontWeight: 700 }}>Henüz firma ataması yapılmış kullanıcı bulunmuyor.</div>
        ) : (
          <div style={{ display: "grid", gap: 10 }}>
            {assignedCompanyReport.map((u) => (
              <div key={u.id || u.uid || u.email} style={{ padding: 14, borderRadius: 14, border: `1px solid ${colors.softBorder}`, background: colors.panel2 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "center", marginBottom: 8 }}>
                  <strong>{u.name || u.email || "-"}</strong>
                  <span style={{ color: colors.muted, fontSize: 13, fontWeight: 900 }}>{u.assignedCompanies.length} firma</span>
                </div>
                <div style={{ color: colors.muted, fontSize: 13, lineHeight: 1.5 }}>
                  {u.assignedCompanies.join(", ")}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ background: colors.panel, color: colors.text, padding: 24, borderRadius: 18, border: `1px solid ${colors.softBorder}`, boxShadow: isDark ? "0 12px 28px rgba(0,0,0,0.18)" : "0 8px 24px rgba(0,0,0,0.06)" }}>
        <h3 style={{ marginTop: 0 }}>Tanımlı Kullanıcılar</h3>

        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "left", padding: 12 }}>Ad-Soyad</th>
              <th style={{ textAlign: "left", padding: 12 }}>E-posta</th>
              {!assignmentOnlyMode && (
                <>
              <th style={{ textAlign: "left", padding: 12 }}>İşe Giriş</th>
              <th style={{ textAlign: "left", padding: 12 }}>Yetki</th>
                </>
              )}
              <th style={{ textAlign: "left", padding: 12 }}>Firma Ataması</th>
              {!assignmentOnlyMode && (
                <>
              <th style={{ textAlign: "left", padding: 12 }}>Atama Yetkisi</th>
              <th style={{ textAlign: "left", padding: 12 }}>Yedek Takibi</th>
              <th style={{ textAlign: "left", padding: 12 }}>Paraşüt Cari</th>
              <th style={{ textAlign: "left", padding: 12 }}>Süreç Projeleri</th>
                </>
              )}
              <th style={{ textAlign: "right", padding: 12 }}>İşlem</th>
            </tr>
          </thead>

          <tbody>
            {users.map((u) => {
              const isCurrentUser =
                String(u.email || "").toLowerCase() ===
                String(currentUserEmail || "").toLowerCase();

              const isLastAdmin = u.role === "admin" && adminCount <= 1;
              const deleteDisabled = isCurrentUser || isLastAdmin;

              return (
                <tr key={u.id}>
                  <td style={{ padding: 12, borderTop: `1px solid ${colors.softBorder}` }}>{u.name || "-"}</td>
                  <td style={{ padding: 12, borderTop: `1px solid ${colors.softBorder}` }}>{u.email}</td>
                  {!assignmentOnlyMode && (
                    <>
                  <td style={{ padding: 12, borderTop: `1px solid ${colors.softBorder}` }}>{u.hireDate || "-"}</td>
                  <td style={{ padding: 12, borderTop: `1px solid ${colors.softBorder}` }}>{u.role === "admin" ? "Admin" : u.role === "editor" ? "Düzenleyici" : "Görüntüleyici"}</td>
                    </>
                  )}
                  <td style={{ padding: 12, borderTop: `1px solid ${colors.softBorder}` }}>{(u.assignedCompanies || []).length > 0 ? `Atanmış Firma (${(u.assignedCompanies || []).length})` : "Atama yok"}</td>
                  {!assignmentOnlyMode && (
                    <>
                  <td style={{ padding: 12, borderTop: `1px solid ${colors.softBorder}` }}>{u.canAssignCompanies ? "Var" : "-"}</td>
                  <td style={{ padding: 12, borderTop: `1px solid ${colors.softBorder}` }}>{u.role === "admin" && u.canMonitorBackups ? "Var" : "-"}</td>
                  <td style={{ padding: 12, borderTop: `1px solid ${colors.softBorder}` }}>{u.role === "admin" && u.canManageParasut ? "Var" : "-"}</td>
                  <td style={{ padding: 12, borderTop: `1px solid ${colors.softBorder}` }}>
                    {u.role === "admin"
                      ? "Tüm Süreç Projeleri"
                      : u.processProjectAccessMode === "assigned"
                      ? `Atanmış Projeler (${(u.assignedProcessProjects || []).length})`
                      : "Tüm Süreç Projeleri"}
                  </td>
                    </>
                  )}
                  <td style={{ padding: 12, borderTop: `1px solid ${colors.softBorder}`, textAlign: "right" }}>

                    <button
                      onClick={() => handleEditUser(u)}
                      style={{
                        padding: "8px 12px",
                        borderRadius: 8,
                        border: "none",
                        background: "#f59e0b",
                        color: "#fff",
                        fontWeight: 600,
                        cursor: "pointer",
                        marginRight: 8
                      }}
                    >
                      Düzenle
                    </button>

                    {isAdmin && (
                      <>
                        <button
                          type="button"
                          onClick={() => sendPasswordResetToUser?.(u)}
                          style={{
                            padding: "8px 12px",
                            borderRadius: 8,
                            border: "none",
                            background: "#0ea5e9",
                            color: "#fff",
                            fontWeight: 600,
                            cursor: "pointer",
                            marginRight: 8
                          }}
                        >
                          Reset Maili
                        </button>

                        <button
                          type="button"
                          onClick={() => generatePasswordResetLinkForUser?.(u)}
                          style={{
                            padding: "8px 12px",
                            borderRadius: 8,
                            border: "none",
                            background: "#7c3aed",
                            color: "#fff",
                            fontWeight: 600,
                            cursor: "pointer",
                            marginRight: 8
                          }}
                        >
                          Reset Linki
                        </button>

                        <button
                          disabled={deleteDisabled}
                          title={isCurrentUser ? "Kendi hesabınızı silemezsiniz." : isLastAdmin ? "Sistemdeki son admin kullanıcısı silinemez." : "Kullanıcıyı sil"}
                          onClick={() => {
                            if (deleteDisabled) return;
                            removeUserPermission(u.email);
                          }}
                          style={{
                            padding: "8px 12px",
                            borderRadius: 8,
                            border: "none",
                            background: deleteDisabled ? "#d1d5db" : "#ef4444",
                            color: "#fff",
                            fontWeight: 600,
                            cursor: deleteDisabled ? "not-allowed" : "pointer",
                            opacity: deleteDisabled ? 0.75 : 1
                          }}
                        >
                          Sil
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              );
            })}

            {users.length === 0 && (
              <tr>
                <td colSpan={assignmentOnlyMode ? 4 : 10} style={{ padding: 16, color: colors.muted }}>
                  Henüz kullanıcı yetkisi tanımlanmamış.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UsersView;
